module.exports = __webpack_public_path__ + "assets/img/btn-view-db983da5.png";